import { debounce, forEach, noop } from 'lodash'
import React, { useEffect } from 'react'
import styled from 'styled-components'

import Button from '../../../Button'
import ButtonGroup from '../../../ButtonGroup'
import FilterRenderer from './FilterRenderer'

const FilterWrapper = styled.div`
  display: flex;
  @media (min-width: 768px) {
    display: flex;
  }
`

const FulltextWrapper = styled.div`
  flex: 1;
  margin-right: 0.75rem;

  @media (min-width: 768px) {
    flex: 1;
    margin-right: 0.75rem;
  }
`
import { FullTextFormProps, IField } from '../../types'

const ButtonGroupWrapper = styled.div``

const Form = (props: FullTextFormProps): React.ReactElement => {
  const {
    form,
    getFormApi = noop,
    filters,
    setFilter,
    apply,
    applyColor,
    setDetailFilterOpen,
    detailFilterOpen,
    hideDetail,
    isMobile,
    fallBackDeleteFilter,
    useLocalStateFiltering,
    applyLocalFilter,
    customFilterBarElement = null,
  } = props

  useEffect((): void => {
    if (form && getFormApi) {
      getFormApi(form)
      const values = { ...props.initialValues }

      form.batch(() => {
        forEach(values, (value, key) => form.change(key, value))
      })
    }
  }, [])

  const reset = (): void => {
    form?.reset()

    if (fallBackDeleteFilter) {
      fallBackDeleteFilter.forEach((element: IField) => {
        form?.change(`${element.field}`, element.value)
      })

      if (useLocalStateFiltering) {
        applyLocalFilter({ reset: true, onlyFts: true })
      } else {
        if (apply) {
          apply(true, false)
        }
      }
    } else {
      if (useLocalStateFiltering) {
        applyLocalFilter({ reset: true, onlyFts: false })
      } else {
        if (apply) {
          apply(true, false)
        }
      }
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent): void => {
    if (event.key === 'Enter') {
      if (useLocalStateFiltering) {
        applyLocalFilter({ reset: false, onlyFts: false })
      } else {
        if (apply) {
          apply(false, true)
        }
      }
    }
  }

  const handlePasteEvent = (): void => {
    if (apply) {
      apply(false, true)
    }
  }

  const debouncedApplyForPasteEvents = debounce(handlePasteEvent, 50)
  return (
    <React.Fragment>
      <FilterWrapper className="mb-1">
        <FilterRenderer
          filters={filters}
          additionalFtsFilters
          handleKeyDown={handleKeyDown}
          setFilter={setFilter}
          isMobile={isMobile}
        />
      </FilterWrapper>
      <FilterWrapper className="mb-1">
        <FulltextWrapper>
          <FilterRenderer
            filters={filters}
            handleKeyDown={handleKeyDown}
            setFilter={setFilter}
            fulltextSearchLoading={props.fulltextSearchLoading}
            apply={apply}
            applyColor={applyColor}
            isMobile={isMobile}
            handlePasteEvent={debouncedApplyForPasteEvents}
          />
        </FulltextWrapper>

        <ButtonGroupWrapper>
          <ButtonGroup>
            <Button
              variant="secondary"
              onClick={reset}
              className="mr-2"
              tooltip={i18n.t('reset_search', 'Zurücksetzen')}
              icon="fas fa-eraser"
              id="infinity-table__clear-filter"
            />

            {!hideDetail && (
              <Button
                variant="info"
                onClick={() =>
                  setDetailFilterOpen({ isDetailOpen: !detailFilterOpen })
                }
                tooltip={i18n.t('open_detail_filter', 'Detailfilter öffnen')}
                icon="fas fa-filter"
                id="infinity-table__button-open-filter"
              />
            )}
          </ButtonGroup>
        </ButtonGroupWrapper>
        {customFilterBarElement}
      </FilterWrapper>
    </React.Fragment>
  )
}

export default Form

export const stringifyValues = (values: unknown): unknown => {
  return values
}
